export function calcInitialPosition(item, parentData) {
  const pos1 = {
    x: item.data.defaultPosition.x,
    y: item.data.defaultPosition.y
  };
  // const pos2 = {x: item.data.x.value, y: item.data.y.value};
  const pos2 = {
    x: item.parentPosition
      ? require('json-pointer').get(parentData, item.parentPosition.x)
      : item.data.x.value,
    y: item.parentPosition
      ? require('json-pointer').get(parentData, item.parentPosition.y)
      : item.data.y.value
  };

  return JSON.stringify(pos1) !== JSON.stringify(pos2) ? pos2 : pos1;
}

export function calcHidden(item) {
  if (item.inherited) {
    return false;
  } else {
    if (typeof item.data.hidden !== 'undefined') {
      return item.data.hidden.value;
    } else {
      return false;
    }
  }
}
